import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IAccount, IReview } from '../interfaces/graph-types';

type ErrorCallback = (err: string) => any;
type SuccessCallback = (data: any) => any;

@Injectable()
export class ReviewService {
  // ------------------------------------------------------
  constructor(private apollo: Apollo) {}

  // ------------------------------------------------------
  public queryGraphQL(query, variables): Observable<any> {
    return this.apollo.watchQuery<any>({
      variables: variables,
      query: query,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
    }).valueChanges;
  }

  // ------------------------------------------------------
  public queryGraphQLPoll(query, variables, pollInterval): Observable<any> {
    return this.apollo.watchQuery<any>({
      variables: variables,
      query: query,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
      pollInterval: pollInterval,
    }).valueChanges;
  }

  // ------------------------------------------------------
  public queryGraphQLNoCache(query, variables): Observable<any> {
    return this.apollo.watchQuery<any>({
      variables: variables,
      query: query,
      fetchPolicy: 'no-cache', // 'network-only' 'cache-and-network', // 'no-cache', //   -> https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-config-options-fetchPolicy
      notifyOnNetworkStatusChange: false,
    }).valueChanges; //.pipe(take(1));
  }

  // ------------------------------------------------------
  public getInfo(accountId: string, reviewId: string): Observable<IReview> {
    return this.apollo
      .watchQuery<{ account: IAccount }>({
        variables: { accountId, reviewId },
        query: gql`
          query reviewInfo($accountId: ID!, $reviewId: ID!) {
            account(accountId: $accountId) {
              id
              review(reviewId: $reviewId) {
                id
                name
                todo {
                  id
                  application {
                    id
                    applicationStepInfos {
                      id
                      response
                      createdAt
                      updatedAt
                      funnelStepVariation {
                        id
                        type
                        required
                        statement
                        descriptionHtml
                        minSelection
                        maxSelection
                        choices
                        minScore
                        manualReview
                        explanation
                        funnelStep {
                          id
                          position
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: false,
      })
      .valueChanges.pipe(map(res => res.data.account.review));
  }
}
